import "./MostPopular.css";

import { Card, SectionHeader, SectionWrapper } from "../../Components";
import mostPopularData from "../../Data/CardData";

const MostPopular = () => {
  const cards = mostPopularData.map((card) => {
    return (
      <Card
        key={card.id}
        image={card.Image}
        title={card.title}
        category={card.category}
        rate={card.rate}
        downloaded={card.downloaded}
      />
    );
  });

  return (
    <div>
      <SectionWrapper>
        <SectionHeader>Most Popular</SectionHeader>
        <div className="most-popular-items">{cards}</div>
      </SectionWrapper>
    </div>
  );
};

export default MostPopular;
